export default __webpack_public_path__ + "static/media/massiel_rivera.bcba62dc.jpeg";